import ListGroupItem from '@/components/ui/list-group/list-group-item'
import Table from '@/components/ui/table/table'
import React from 'react'
import Textarea from '@/components/forms/form-elements/textarea'
import Checkbox from '@/components/forms/form-elements/checkbox'
import Button from '@/components/ui/button/button'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import styled from 'styled-components'
import { useForm } from 'react-hook-form'
import numberUtils from '@/utils/numberUtils'
import { SEO } from '@/components/seo/seo'
import { useResponsive } from '@/hooks/useResponsive'

const Container = styled.div`
  text-align: center;
  margin-top: 50px;
`

const Title = styled.h1`
  text-align: left;
`

const SubTitle = styled.p`
  text-align: left;
`

const SectionTitle = styled.h2`
  text-align: left;
  margin-top: 20px; // 상단 여백
  margin-bottom: 20px; // 하단 여백
`

const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 20px;
`

const ErrorMessage = styled.p`
  color: red;
  font-size: 14px;
  margin-top: 5px;
`

const Member: React.FC = () => {
  const navigate = useNavigate()
  const isLogin = true
  const axios = useAxios()
  const { showAlert, showConfirm } = useDialog()
  const { setFocus } = useForm<{ [key: string]: any }>()
  const [termsResponses, setTermsResponses] = useState<string[]>([])
  const [checkedItems, setCheckedItems] = useState<boolean[]>([
    false,
    false,
    // false,
  ])
  const [errorMessages, setErrorMessages] = useState<string[]>(['', '', ''])
  const { isMobile, isTablet, isDesktop } = useResponsive()

  useEffect(() => {
    fetchTermsData()
  }, [])

  // 약관 정보 가져오기
  const fetchTermsData = async () => {
    try {
      const response = await axios.get('/agree/selectTermsMasterList')
      setTermsResponses(response.data.map((item: any) => item.termsCont))
    } catch (error) {
      console.error('Error fetching terms:', error)
    }
  }

  // 체크박스 상태 변경
  const handleCheckboxChange = (index: number) => {
    setCheckedItems((prev) => {
      const newCheckedItems = [...prev]
      newCheckedItems[index] = !newCheckedItems[index]
      return newCheckedItems
    })

    // 체크하면 오류 메시지 제거
    setErrorMessages((prev) => {
      const newErrors = [...prev]
      newErrors[index] = ''
      return newErrors
    })
  }

  const buttonHandler = (pathName: string) => {
    if (pathName === 'agree') {
      let hasError = false
      const messages = [
        '이용약관에 동의해주세요.',
        '개인 정보 취급 방침에 동의해주세요.',
        // '개인정보 취급 위탁 동의서에 동의해주세요.',
      ]

      // 0, 1, 2번 인덱스를 순차적으로 확인
      for (let index = 0; index < checkedItems.length; index++) {
        if (!checkedItems[index]) {
          showAlert({
            type: 'warning',
            message: messages[index],
            onClose: () => {
              const focusKey = `memberCheck_${index + 1}`
              setFocus(focusKey)
            },
          })
          hasError = true
          break // 오류가 발생하면 더 이상 반복하지 않음
        }
      }

      // 오류가 없으면 동의 진행
      if (!hasError) {
        // 실제 처리
        const routes: Record<string, string> = {
          agree: '/member/newMember',
          cancle: '/main',
        }
        navigate(routes[pathName] || '/member')
      }
    }

    window.scrollTo(0, 0)
  }

  return (
    <>
      <SEO
        title="회원가입"
        //description="꿀프에서 골프 관련 서비스를 확인하세요."
        canonicalUrl="https://ggoollff.co.kr/member"
      />

      <div className="agree-container">
        <h1 className="agree-page-title">약관동의</h1>

        {termsResponses.map((terms, index) => (
          <div className="agree-section" key={index}>
            <h2 className="agree-section-title">
              {
                [
                  '이용약관',
                  '개인 정보 취급 방침',
                  // '개인정보 취급 위탁 동의서', // 미사용 약관
                ][index]
              }
            </h2>

            {/* <div className="agree-terms-box">
              <div className="agree-terms-content">
                <textarea
                  id={`memberArea_${index + 1}`}
                  name={`memberArea_${index + 1}`}
                  value={terms}
                  readOnly
                  style={{ width: '100%', height: '250px' }}
                />
              </div>

              <div className="agree-checkbox-area">
                <div className="agree-checkbox-item">
                  <input
                    type="checkbox"
                    id={`memberCheck_${index + 1}`}
                    name={`memberCheck_${index + 1}`}
                    checked={checkedItems[index]}
                    onChange={() => handleCheckboxChange(index)}
                  />
                  <label htmlFor={`memberCheck_${index + 1}`}>
                    동의합니다.
                  </label>
                </div>
                {errorMessages[index] && (
                  <div className="error-message">{errorMessages[index]}</div>
                )}
              </div>
            </div> */}
            <textarea
              id={`memberArea_${index + 1}`}
              name={`memberArea_${index + 1}`}
              value={terms}
              readOnly
              style={{ width: '100%', height: '250px' }}
            />
            <div className="agree-checkbox-item">
              <input
                type="checkbox"
                id={`memberCheck_${index + 1}`}
                name={`memberCheck_${index + 1}`}
                checked={checkedItems[index]}
                onChange={() => handleCheckboxChange(index)}
              />
              <label htmlFor={`memberCheck_${index + 1}`}>동의합니다.</label>
            </div>
            {errorMessages[index] && (
              <div className="error-message">{errorMessages[index]}</div>
            )}
          </div>
        ))}

        <div className="member-button-group">
          <button
            type="button"
            className="member-btn-submit"
            onClick={() => buttonHandler('agree')}
          >
            동의합니다
          </button>
          <button
            type="button"
            className="member-btn-cancel"
            onClick={() => buttonHandler('cancle')}
          >
            동의하지 않습니다
          </button>
        </div>
      </div>
    </>
  )
}

export default Member
